import { ReactElement, useState } from 'react';

import { AnimationStyle } from '@/models/Animation.ts';

interface AnimationIconHook {
    animatedComponentId: string | undefined;
    setId: (id: string | undefined) => void;
    animationClass: string;
    baseClass: string;
    styleElement: ReactElement;
}

const bellAnimationClass = `
@keyframes wiggle {
    0% { transform: rotate(0deg); }
    10% { transform: rotate(25deg); }
    20% { transform: rotate(15deg); }
    30% { transform: rotate(0deg); }
    40% { transform: rotate(-25deg); }
    50% { transform: rotate(-15deg); }
    60% { transform: rotate(0deg); }
    70% { transform: rotate(10deg); }
    80% { transform: rotate(0deg); }
    90% { transform: rotate(-10deg); }
    100% { transform: rotate(0deg); }
}

/* Single class that combines both effects */
.bell-active {
    height: 0.875rem !important; /* size-3.5 */
    width: 0.875rem !important; /* size-3.5 */
    animation: wiggle 0.8s ease-in-out infinite;
    will-change: transform;
    backface-visibility: hidden;
}
`;

const effectMapping = {
    [AnimationStyle.BELL_WIGGLE]: bellAnimationClass,
};

const coreAnimationClasses = {
    [AnimationStyle.BELL_WIGGLE]: {
        active: 'bell-active',
        base: 'transition-all duration-200',
    },
};

const useAnimatedIcon = (animationEffect: AnimationStyle, probability?: number): AnimationIconHook => {
    const [animatedComponentId, setAnimatedComponentId] = useState<string | undefined>(undefined);

    const setId = (id: string | undefined): void => {
        if (!id) {
            setAnimatedComponentId(undefined);
            return;
        }

        if (!probability || Math.random() < probability) {
            setAnimatedComponentId(id);
        }
    };

    return {
        animatedComponentId: animatedComponentId,
        setId: setId,
        animationClass: coreAnimationClasses[animationEffect].active,
        baseClass: coreAnimationClasses[animationEffect].base,
        styleElement: <style>{effectMapping[animationEffect]}</style>,
    };
};

export default useAnimatedIcon;
